 (function(){
  function animateOpen(details, content){
    details.classList.add('opening');
    details.setAttribute('open','');
    var target = content.scrollHeight;
    // Web Animations path
    if(content.animate){
      // Set explicit start height
      content.style.height = '0px';
      var anim = content.animate([
        { height:'0px', opacity:0 },
        { height: target + 'px', opacity:1 }
      ], { duration:280, easing:'cubic-bezier(.4,0,.2,1)' });
      anim.onfinish = function(){
        details.classList.remove('opening');
        details.classList.add('open');
        content.style.height = 'auto';
      };
      return;
    }
    // Fallback CSS transition
    content.style.height = '0px';
    content.getBoundingClientRect();
    requestAnimationFrame(function(){ content.style.height = target + 'px'; });
    function cleanup(e){
      if(e.target !== content) return;
      content.removeEventListener('transitionend', cleanup);
      details.classList.remove('opening');
      details.classList.add('open');
      content.style.height = 'auto';
    }
    content.addEventListener('transitionend', cleanup);
  }

  function animateClose(details, content){
    details.classList.add('closing');
    // If auto height, fix it first
    if(getComputedStyle(content).height === 'auto' || content.style.height === 'auto'){
      content.style.height = content.scrollHeight + 'px';
    }
    var start = content.scrollHeight;
    if(content.animate){
      var anim = content.animate([
        { height: start + 'px', opacity:1 },
        { height:'0px', opacity:0 }
      ], { duration:250, easing:'cubic-bezier(.4,0,.2,1)' });
      anim.onfinish = function(){
        details.classList.remove('closing','open');
        details.removeAttribute('open');
        content.style.height = '0px';
      };
      return;
    }
    content.style.height = start + 'px';
    content.getBoundingClientRect();
    requestAnimationFrame(function(){ content.style.height = '0px'; });
    function cleanup(e){
      if(e.target !== content) return;
      content.removeEventListener('transitionend', cleanup);
      details.classList.remove('closing','open');
      details.removeAttribute('open');
      content.style.height = '0px';
    }
    content.addEventListener('transitionend', cleanup);
  }
  function initCollapsibles(){
    document.querySelectorAll('.collapsible-content .collapsible-row').forEach(function(details){
      var summary = details.querySelector('summary');
  var content = details.querySelector('.accordion__content');
      if(!summary || !content) return;

      // If rendered initially open (from Liquid), convert to animated open state
      if(details.hasAttribute('open')){
        details.classList.add('open');
        content.style.height = 'auto';
      }

      summary.setAttribute('role','button');
      summary.setAttribute('aria-expanded', details.classList.contains('open'));
      summary.addEventListener('click', function(e){
        e.preventDefault();
        if(details.classList.contains('opening') || details.classList.contains('closing')) return; // prevent double triggers
        var isOpen = details.classList.contains('open');
        summary.setAttribute('aria-expanded', !isOpen);
        if(isOpen){
          animateClose(details, content);
        } else {
          animateOpen(details, content);
        }
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initCollapsibles);
  } else {
    initCollapsibles();
  }

  // Recompute heights for open items on resize
  var resizeTimeout;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function(){
      document.querySelectorAll('.collapsible-content .collapsible-row.open .accordion__content').forEach(function(content){
        content.style.height = 'auto';
      });
    }, 150);
  });
})();